! function ($) {
  "use strict";

  $(".product_category_button_group button").on("click", function () {
    var $this = $(this);
    $this.closest(".product_category_button_group").find("button").removeClass("active");
    $this.addClass("active");

    // Image
    var imageIndex = parseInt($this.data("image-index"));
    if (!isNaN(imageIndex)) {
      $(".slider-for").slick("slickGoTo", imageIndex, true);
      $(".product_image_small")
        .removeClass("active")
        .eq(imageIndex)
        .addClass('active');
    }

    var key = $(".product_category_button_group button.active")
      .map(function () { return $(this).data("key"); })
      .toArray()
      .join("-");

    if (window.products.hasOwnProperty(key)) {
      var product = window.products[key];

      $(".price font").html(`市售價：${product.oldPrice}元`)
      if (product.specialPrice) {
        $(".price").find("font").css({ color: "#999" })
        $(".price span").show().find("b").html(product.specialPrice)
      } else {
        $(".price").find("font").css({ color: "#333" })
        $(".price span").hide()
      }
      if (product.availableAmount === 0) {
        $(".quantity_area, .product_buy_button").addClass("sold_out")
      } else {
        $(".quantity_area, .product_buy_button").removeClass("sold_out")
      }
      $('#inputCartAmount')
        .attr("max", product.availableAmount)
        .val(1);
    }
  });

  $(document).ready(function () {
    var $buttons = $(".product_detail .product_category_button_group button");
    if ($buttons.length == 1) {
      $buttons.trigger("click");
    }
  });

  $(".product_addon select").on("change", function () {
    var $this = $(this);
    var $checkbox = $this.parent().find("input[type=checkbox]");
    if ($this.val() == 0) {
      $checkbox.prop("checked", false);
    } else {
      $checkbox.prop("checked", true);
    }
  });

  $(".product_addon .product_h").on("click", function (e) {
    e.preventDefault();
    if ($(e.target).is("select")) {
      return;
    }

    var $select = $(this).find("select");
    if ($select.length == 0) {
      return;
    }
    if ($select.val() == 0) {
      $select.val(1).change();
    } else {
      $select.val(0).change();
    }
  });


  // 倒數
  if (window.countdownEndTime != null) {
    layoutJS.counterDate(new Date(window.countdownEndTime));
  }

  if (!location.pathname.toLowerCase().endsWith("priview")) {

    $(".product_buy_button").on("click", function () {
      var $this = $(this);
      if ($this.hasClass("sold_out")) {
        return;
      }

      var key = $(".product_category_button_group button.active")
        .map(function () { return $(this).data("key"); })
        .toArray()
        .join("-");

      if (!window.products.hasOwnProperty(key)) {
        alert("請選擇規格");
        return;
      }

      var product = window.products[key];
      var amount = $("#inputCartAmount").val();

      if (amount == 0) {
        return;
      }

      var addonProductIds = {};
      $(".product_addon .product_h select").each(function () {
        var $this = $(this);
        if ($this.val() > 0) {
          addonProductIds[$this.data("product-id")] = $this.val()
        }
      });

      $.ajax({
        type: "POST",
        url: "/order/cart?handler=add",
        data: {
          "input.productId": product.id,
          "input.amount": amount,
          "input.addonProductIds": addonProductIds
        },
        dataType: "json",
        beforeSend: function () {
          $(".product_buy_button").prop("disabled", true);
        },
        complete: function () {
          $(".product_buy_button").prop("disabled", false);
        },
        success: function (response) {
          if (response.error !== undefined) {
            var $alert = $(`<div class="alert alert-danger alert-dismissible fade show" role="alert">
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
              <span></span>
            </div>`);
            $alert.find("span").text(response.error);
            $("#containerStatusMessage").append($alert);
            return;
          }

          var addCartProducts = { ...addonProductIds };
          addCartProducts[product.id] = amount;

          var gtagItem = { currency: 'TWD', items: [] };
          var fbItem = { currency: 'TWD', content_type: 'product', contents: [] };
          var totalValue = 0;
          Object.keys(addCartProducts).forEach(key => {
            var gItem = Object.assign({}, window.AddCartGTagItemMap[key]);
            var fItem = Object.assign({}, window.AddCartFacebookPixelItemMap[key]);
            var quantity = addCartProducts[key];
            gItem.quantity = quantity;
            fItem.quantity = quantity;
            gtagItem.items.push(gItem);
            fbItem.contents.push(fItem);
            totalValue += (gItem.price * quantity);
          });
          gtagItem.value = totalValue;
          fbItem.value = totalValue;
          gtag('event', 'add_to_cart', gtagItem);
          fbq('track', 'AddToCart', fbItem);

          if ($this.hasClass("buy_now")) {
            window.location.href = "/order/cart";
            return;
          }

          var $alert = $(`<div class="alert alert-success alert-dismissible fade show" role="alert">
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
              <span></span>
            </div>`);
          $alert.find("span").text(response.message);
          $("#containerStatusMessage").append($alert);
          $(".alert").delay(4000).slideUp(200, function () {
            $(this).delete();
          });

          $(".product_addon select").val(0).change();

          var $cartNumber = $("header .add_item_num");
          $cartNumber.text(response.cartItemCount);
          if (response.cartItemCount > 0) {
            $cartNumber.css("visibility", "visible");
          } else {
            $cartNumber.css("visibility", "hidden")();
          }
          $("html, body").animate({ scrollTop: 0 }, "slow");
        },
        error: function (request, status, error) {
          alert("系統發生錯誤");
        }
      });
    });
  }

}(window.jQuery);